//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../forumLandingFormModule.scss'
import { useForm } from 'react-hook-form';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
import { ILangingForums } from 'app_types/admin/landings/landingTypes';

// @ADD Component types
interface IForumLandingFormModuleLayoutProps {
  forumData: ILangingForums
  permission: any
  source: string
  loading: boolean
  onHandleForumSubmit: (data: any) => void | null
}

const ForumLandingFormModuleLayout: React.FC<IForumLandingFormModuleLayoutProps> = (props) => {

  const { t } = useTranslation()
  const formHook = useForm()

  return(
    <div className='forum_landing_form_module-layout'>
      <div className="d-flex align-items-center mb-2">
        <h3 className="form-title">{t("modules.teacher_landing_form.sections.forums")}</h3>
      </div>
      <form onSubmit={formHook.handleSubmit(props.onHandleForumSubmit)} >
        <div className="col-12">
          <div className="form-group">
            <label htmlFor='title'>{t('labels.teacher_landing_form.title_forums')}</label>
            {formHook.errors.title && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
            <input
              id='title'
              name='title'
              className={`form-control ${formHook.errors.title && 'is-invalid'}`}
              type='text'
              ref={formHook.register({ required: true })}
              defaultValue={props?.forumData?.title}
            />
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label htmlFor='description'>{t('labels.teacher_landing_form.description_forums')}</label>
            {formHook.errors.description && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
            <input
              id='description'
              name='description'
              className={`form-control ${formHook.errors.description && 'is-invalid'}`}
              type='text'
              ref={formHook.register({ required: true })}
              defaultValue={props?.forumData?.description}
            />
          </div>
        </div>
        <div className='buttons-group'>
          <div className='text-center'>
            <ButtonComponent
              loading={props.loading}
              type='submit'
              variant='primary'
            >
              {t('modules.modal_scheduling_form.form.save')}
            </ButtonComponent>
          </div>
        </div>
      </form>
    </div>
  )
}

export default ForumLandingFormModuleLayout
